/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Generation_FailedInputs */

const en_us2_chat_generation_failed = /** @type {(inputs: Chat_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong while writing that answer. Try asking again.`)
};

const pt_br2_chat_generation_failed = /** @type {(inputs: Chat_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deu algo errado ao escrever essa resposta. Pergunte de novo.`)
};

const es_419_chat_generation_failed = /** @type {(inputs: Chat_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal al escribir esa respuesta. Pregunta de nuevo.`)
};

const pt_pt2_chat_generation_failed = /** @type {(inputs: Chat_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo correu mal ao escrever essa resposta. Pergunta outra vez.`)
};

const fr_fr2_chat_generation_failed = /** @type {(inputs: Chat_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un problème est survenu pendant la rédaction de la réponse. Repose ta question.`)
};

const de_de2_chat_generation_failed = /** @type {(inputs: Chat_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Schreiben dieser Antwort ist etwas schiefgelaufen. Frag noch mal.`)
};

const it_it2_chat_generation_failed = /** @type {(inputs: Chat_Generation_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto mentre scrivevo la risposta. Prova a chiedere di nuovo.`)
};

/**
* | output |
* | --- |
* | "Something went wrong while writing that answer. Try asking again." |
*
* @param {Chat_Generation_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_generation_failed = /** @type {((inputs?: Chat_Generation_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Generation_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_generation_failed(inputs)
	if (locale === "es-419") return es_419_chat_generation_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_generation_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_generation_failed(inputs)
	if (locale === "de-DE") return de_de2_chat_generation_failed(inputs)
	if (locale === "it-IT") return it_it2_chat_generation_failed(inputs)
	return en_us2_chat_generation_failed(inputs)
});
export { chat_generation_failed as "chat.generation_failed" }